import React from 'react';
import ImageUploading from 'react-images-uploading';
import { Modal, Button, useToaster, Message } from 'rsuite';
import './image-style.css';
import Drag from './drag-and-drop.jpg';
import axios from 'axios';
import globalIP from '@/GlobelIP';
const SmartSearchModal = ({
  open,
  close,
  setStopInfininitescrol,
  storeAllImagePath,
  setFetchedProducts
}) => {
  const [images, setImages] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const toaster = useToaster();
  const maxNumber = 69;
  const onChange = imageList => {
    setImages(imageList);
  };
  const handleSearchImage = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('filterImage', images[0].file);
    formData.append('threshold', '140');
    formData.append('image-paths', JSON.stringify(storeAllImagePath));
    const res = await axios.post(
      `http://192.168.1.9:4044/api/client-upload-image-search`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    );
    const { sameId } = res.data;

    if (sameId.length) {
      const promises = sameId.map(async id => {
        const { data } = await axios.get(`${globalIP}/api/products/${id}?populate=*`);
        return data.data;
      });
      const allData = await Promise.all(promises);
      setFetchedProducts(allData);
      close();
    } else {
      toaster.push(
        <Message showIcon type="error">
          Not Found.
        </Message>,
        { placement: 'topCenter' }
      );
    }
    setIsLoading(false);
  };
  return (
    <>
      <Modal
        overflow={false}
        open={open}
        onClose={() => {
          close();
          setStopInfininitescrol(true);
        }}
      >
        <Modal.Header>
          <Modal.Title style={{ textAlign: 'center', fontSize: '20px', fontWeight: '400' }}>
            Search any image with Google Lens
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="App">
            <ImageUploading
              value={images}
              onChange={onChange}
              maxNumber={maxNumber}
              dataURLKey="data_url"
            >
              {({ imageList, onImageUpload, isDragging, dragProps }) => (
                <div className="upload__image-wrapper">
                  <button
                    style={isDragging ? { color: 'red', fontSize: '20px' } : { fontSize: '20px' }}
                    onClick={onImageUpload}
                    {...dragProps}
                    className="image-uploader"
                  >
                    {imageList.length ? null : (
                      <>
                        <img src={Drag} alt="" style={{margin:"auto"}}/>
                        Drag an image here or upload a file
                      </>
                    )}
                    {imageList.map((image, index) => (
                      <div key={index} className="image-item">
                        <img src={image['data_url']} alt="" width="100" />
                      </div>
                    ))}
                  </button>
                </div>
              )}
            </ImageUploading>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            appearance="primary"
            disabled={images.length ? false : true}
            color="cyan"
            onClick={handleSearchImage}
            loading={isLoading}
          >
            Search
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default SmartSearchModal;
